'use client';

import { useCallOperatorControls } from '@callixbrasil/client-sdk-react';

/**
 * Hook to manage operator break state using the SDK's native methods.
 * The SDK provides enterOnBreak() and becomeAvailable() methods directly.
 */
export function useOperatorBreak() {
  // The SDK already exposes enterOnBreak and becomeAvailable!
  const { enterOnBreak, becomeAvailable } = useCallOperatorControls();

  return {
    // Use the SDK's native method
    goOnBreak: enterOnBreak,
    // becomeAvailable exits the break and makes operator available
    goOffBreak: becomeAvailable,
  };
}
